export const light = {
  bg: {
    main: "#FFFFFF",
    secondary: "#F0F4F8",
    neutral: "#D9E2EC",
  },
  text: {
    main: "#102A43",
    secondary: "#243B53",
    neutral: "#829AB1",
  },
  shadow: "rgba(16, 42, 67, 0.5)",
}

export const dark = {
  bg: {
    main: "#102A43",
    secondary: "#243B53",
    neutral: "#334E68",
  },
  text: {
    main: "#F0F4F8",
    secondary: "#D9E2EC",
    neutral: "#627D98",
  },
  shadow: "rgba(240, 244, 248, 0.2)",
}

export const warm = {
  bg: {
    main: "#27241D",
    secondary: "#423D33",
    neutral: "#504A40",
  },
  text: {
    main: "#FAF9F7",
    secondary: "#E8E6E1",
    neutral: "#A39E93",
  },
  shadow: "rgba(250, 249, 247, 0.2)",
}

export const commonStyles = {
  breakpoints: {
    mobile: "only screen and (max-width: 50rem)",
    tablet: "only screen and (max-width: 65rem)",
  },
  spacing: {
    xxSmall: ".25rem",
    xSmall: ".5rem",
    small: "1rem",
    medium: "2rem",
    large: "3rem",
    xLarge: "4rem",
    xxLarge: "5rem",
  },
  animations: {
    button: "box-shadow 0.3s ease",
    link: "color 0.2s ease",
    theme: "background-color 0.3s, font-family 0.3s",
  },
  shadows: {
    shadow1: "0px 5px 20px rgba(30,30,31,0.05)",
  },
  pill: {
    development: "#BB6BD9",
    motivation: "#6FCF97",
    productivity: "#56CCF2",
    default: "#102A43",
  },
  fonts: {
    handwriting: "Handlee",
    main: "Poppins, sans-serif",
    code: "Roboto Mono, monospace",
    blog: "Inter",
    heading: {
      sans: "Poppins, Sans Serif",
      serif: "Roboto Slab",
    },
    paragraph: {
      sans: "Inter, Roboto Condensed",
      serif: "Taviraj, Serif",
    },
  },
}

export const font = {
  sans: {
    heading: "Poppins, Sans Serif",
    paragraph: "Inter",
  },
  serif: {
    heading: "Merriweather",
    paragraph: "Poppins",
  },
  slab: {
    heading: "Roboto Slab, Serif",
    paragraph: "Roboto",
  },
}
